// @ts-nocheck
import { createAsyncActionTypes } from '../../../core/store/actionCreators';

export const CLEAR_TRACERS = 'tracer/clearTracers';
export const {
  pending: CLEAR_TRACERS_PENDING,
  fulfilled: CLEAR_TRACERS_FULFILLED,
  rejected: CLEAR_TRACERS_REJECTED,
} = createAsyncActionTypes(CLEAR_TRACERS);
